import React from 'react';

/**
 * THE toolbar control box: 24 px square, bordered, blue when its state is on
 * — the same recipe the Text, Design and font triggers draw, so every pill
 * (set elements and design elements alike) reads as one row of equal
 * controls. Icons are 14 px. Use this for any button that lives in a pill;
 * never a bare icon.
 */
export const TOOLBAR_BOX = 'h-6 rounded border transition-colors flex items-center justify-center';
export const TOOLBAR_BOX_ON = 'bg-blue-500 border-blue-400 text-white';
export const TOOLBAR_BOX_OFF = 'bg-black/40 border-white/20 text-white/80 hover:bg-black/60';

export const ToolbarButton: React.FC<{
  title: string;
  /** On = blue, like a Text style that is set. */
  active?: boolean;
  /** Mark as a toggle (reads `active` as pressed) when the button holds a state. */
  toggle?: boolean;
  onClick: () => void;
  disabled?: boolean;
  dataAttrs?: Record<`data-${string}`, string | undefined>;
  children: React.ReactNode;
}> = ({ title, active = false, toggle = false, onClick, disabled = false, dataAttrs, children }) => (
  <button
    type="button"
    onClick={(e) => { e.stopPropagation(); onClick(); }}
    disabled={disabled}
    title={title}
    aria-label={title}
    aria-pressed={toggle ? active : undefined}
    className={`w-6 ${TOOLBAR_BOX} ${active ? TOOLBAR_BOX_ON : TOOLBAR_BOX_OFF} disabled:opacity-40`}
    {...dataAttrs}
  >
    {children}
  </button>
);
